import API from '../../../api/axios';

const requestService = {
    async getRequest(id) {
        const { data } = await API.get(`/request/${id}`);
        return data;
    },

    async getMessages(id) {
        const { data } = await API.get(`/request/${id}/messages`);
        return data;
    },

    async getParticipants(id) {
        const { data } = await API.get(`/request/${id}/participants`);
        return data;
    },

    async updateStatus(id, status) {
        const { data } = await API.patch(`/request/${id}`, { status });
        return data;
    },

    async sendMessage(id, payload) {
        const { data } = await API.post(`/request/${id}/messages`, payload);
        return data;
    },

    async addParticipants(id, shopIds) {
        const { data } = await API.post(`/request/${id}/participants`, { shopIds });
        return data;
    },

    async removeParticipant(id, participantId) {
        const { data } = await API.delete(`/request/${id}/participants/${participantId}`);
        return data;
    },

    async searchMotos(id, payload) {
        const { data } = await API.post(`/request/${id}/moto-search`, payload);
        return data;
    },
    async generateMotoQuote(id, payload) {
        const { data } = await API.post(`/request/${id}/moto-quote`, payload);
        return data;
    },
};

export default requestService;